import { Component } from '@angular/core';
import {MarcacaoService} from "../../services/marcacao.service";
import {SharedMarcacaoService} from "../../services/shared-marcacao.service";
import {ToastrService} from "ngx-toastr";
import {MarcacaoModel} from "../../models/marcacao.model";
import {AuthTokenService} from "../../services/auth-token.service";
import {MedicoService} from "../../services/medico.service";
import {MedicoModel} from "../../models/medico.model";
import {BaseResponseDTO} from "../../models/base-response-dto.model";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TiposConselhoPrimaryKey} from "../../models/tipos-conselho.model";
import {TiposConselhoService} from "../../services/tipos-conselho.service";
import {EspecialidadeModel} from "../../models/especialidade.model";
import {EspecialidadeService} from "../../services/especialidade.service";

@Component({
  selector: 'app-prontuarios-avulsos',
  templateUrl: './prontuarios-avulsos.component.html',
  styleUrls: ['./prontuarios-avulsos.component.scss']
})
export class ProntuariosAvulsosComponent {
  protected nomePaciente: string | undefined;
  protected dtNascimento: Date | undefined;
  protected dtAtendimento: Date | undefined;
  protected cpf: string | undefined;
  protected medico: MedicoModel | undefined;
  protected medicoSelecionado: boolean = false;
  protected tipoConselho: string | undefined;
  protected prontuarios: MarcacaoModel[] = [];
  protected prontuarioAtual: MarcacaoModel | undefined;
  protected especialidade: EspecialidadeModel | undefined;
  protected abaAtivaMenu: string = 'prescricao';

  constructor(private marcacaoService: MarcacaoService,
              private sharedMarcacaoService: SharedMarcacaoService,
              private especialidadeService: EspecialidadeService,
              private toastrService: ToastrService,
              private authTokenService: AuthTokenService,
              private medicoService: MedicoService,
              private tiposConselhosService: TiposConselhoService,
              private modalService: NgbModal) {
    const medicoId = this.authTokenService.medicoId;
    this.medicoService.get(medicoId!).subscribe((res) => {
      this.medico = res.data;
    });

    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.prontuarioAtual = res;

      if (res) {
        const tipoConselhoPk = Object.assign(new TiposConselhoPrimaryKey(), {tipo_Conselho: this.prontuarioAtual?.corpoClinico?.profissional?.tipo_Conselho});
        this.tiposConselhosService.get(tipoConselhoPk).subscribe(res => {
          this.tipoConselho = res.data?.descricao;
        });

        this.especialidadeService.getByMedico(this.prontuarioAtual?.corpoClinico?.profissional!).subscribe((res) => {
          this.especialidade = res.data;
        });
      } else {
        this.tipoConselho = undefined;
        this.especialidade = undefined;
      }
    });
  }

  protected filtrar(modal: any) {
    this.marcacaoService.getAllAvulsosByFiltros(this.nomePaciente, this.dtNascimento, undefined, this.dtAtendimento, this.cpf, this.medicoSelecionado ? this.medico! : undefined)
      .subscribe(res => {
    // Ordena os registros do mais recente para o mais antigo antes de enviar para o modal
    if (res && res.data && Array.isArray(res.data)) {
      res.data.sort((a, b) => new Date(b.data_Agenda).getTime() - new Date(a.data_Agenda).getTime());
    }  
    this.tratarRetornoProntuariosAvulsos(res, modal);
  });      
  }

  protected limpaCampos() {
    this.nomePaciente = undefined;
    this.dtNascimento = undefined;
    this.dtAtendimento = undefined;
    this.cpf = undefined;
    this.medicoSelecionado = false;
    this.prontuarios = [];
  }

  protected selecionarProntuario(prontuario: MarcacaoModel) {
    this.sharedMarcacaoService.setMarcacaoAtual(prontuario);
  }

  protected fechaProntuario() {
    this.sharedMarcacaoService.setMarcacaoAtual(undefined);
  }

  private tratarRetornoProntuariosAvulsos(res: BaseResponseDTO<MarcacaoModel[]>, modal: any) {
    if (res.data.length == 0) {
      this.toastrService.warning('Nenhum prontuário encontrado', 'Atenção');
      this.sharedMarcacaoService.setMarcacaoAtual(undefined);
    } else if (res.data.length == 1) {
      this.sharedMarcacaoService.setMarcacaoAtual(Object.assign(new MarcacaoModel(), res.data[0]));
    } else {
      this.sharedMarcacaoService.setMarcacaoAtual(undefined);
      this.prontuarios = res.data.map((m) => Object.assign(new MarcacaoModel(), m));
      this.modalService.open(modal, { centered: false, windowClass: 'full-screen-modal', backdrop: 'static' });
    }
  }
  
  public mudarAbaMenu(aba: string) {
  this.abaAtivaMenu = aba;
}
}
